<div
	class="mt-5 px-4"
	[ngClass]="shouldDisplayDivider ? 'border-t-2 pt-5 border-grey-lighter' : ''"
>
	<h5 class="font-medium">Primary Benefits</h5>
	<div
		class="flex flex-row mt-3 text-sm/6 items-start"
		*ngFor="let benefit of benefits"
	>
		<app-icon [icon]="ICON.SUCCESS" class="mr-2 text-green" />
		<p>{{ benefit }}</p>
	</div>
</div>
